import React, { useState } from 'react';
import { useClientPortal } from '../contexts/ClientPortalContext';
import OrderSummaryModal from './OrderSummaryModal';
import CancelOrderModal from './CancelOrderModal';
import logo from '../images/logo.png';

const AdaptiveHeader = ({ onShowClientLogin }) => {
    const { 
        isLoggedIn, 
        user, 
        logout, 
        orderStarted, 
        startOrder, 
        cancelOrder, 
        cart, 
        getTotalItems 
    } = useClientPortal();

    const [showOrderSummary, setShowOrderSummary] = useState(false);
    const [showCancelModal, setShowCancelModal] = useState(false);

    const handleStartOrder = () => {
        startOrder();
    };

    const handleValidateOrder = () => {
        if (cart.length === 0) {
            alert('Your cart is empty! Please add some products before validating.');
            return;
        }
        setShowOrderSummary(true);
    };

    const handleCancelOrder = () => {
        setShowCancelModal(true);
    };

    const confirmCancelOrder = () => {
        cancelOrder();
        setShowCancelModal(false);
    };

    if (!isLoggedIn) {
        // Interface publique - pas connecté
        return (
            <header className="main-header">
                <div className="main-header-title">
                    <img src={logo} alt="Logo" className="header-logo" />
                    <div className="header-text-container">
                        {/* Product Catalog text removed — keeping subtitle for context */}
                        <p className="main-header-subtitle">
                            Real-time inventory data
                        </p>
                    </div>
                </div>
                <div className="main-header-buttons">
                    <button
                        className="main-header-btn main-header-btn-client"
                        onClick={onShowClientLogin}
                        onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                        onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                    >
                        👤 DISTRIBUTOR ACCESS
                    </button>
                </div>
            </header>
        );
    }

    // Interface client connecté
    return (
        <>
            <header className="main-header" style={{ 
                background: orderStarted ? '#e8f5e8' : 'transparent',
                borderBottom: orderStarted ? '3px solid #4CAF50' : 'none'
            }}>
                <div className="main-header-title">
                    <img src={logo} alt="Logo" className="header-logo" />
                    <div className="header-text-container">
                        {/* Product Catalog text removed for a cleaner header, subtitle kept and personalized */}
                        <p className="main-header-subtitle">
                            Real-time inventory data — Welcome back, {user.name || user.email}!
                            {orderStarted && cart.length > 0 && (
                                <span style={{ color: '#4CAF50', marginLeft: '10px' }}>
                                    🛒 {getTotalItems()} item(s) in cart
                                </span>
                            )}
                            {orderStarted && <span style={{ color: '#4CAF50', marginLeft: '10px' }}> - Order Mode</span>}
                        </p>
                    </div>
                </div>
                
                <div className="main-header-buttons">
                    {!orderStarted ? (
                        <>
                            <button
                                className="main-header-btn"
                                style={{
                                    background: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
                                    color: 'white'
                                }}
                                onClick={handleStartOrder}
                                onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                                onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                            >
                                🛒 Start Your Order
                            </button>
                        </>
                    ) : (
                        <>
                            <button
                                className="main-header-btn"
                                style={{
                                    background: 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)',
                                    color: 'white'
                                }}
                                onClick={handleCancelOrder}
                                onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                                onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                            >
                                ❌ Cancel Order
                            </button>
                            
                            <button
                                className="main-header-btn"
                                style={{
                                    background: cart.length > 0 
                                        ? 'linear-gradient(135deg, #2196F3 0%, #1976D2 100%)'
                                        : '#ccc',
                                    color: 'white',
                                    cursor: cart.length > 0 ? 'pointer' : 'not-allowed'
                                }}
                                onClick={handleValidateOrder}
                                disabled={cart.length === 0}
                                onMouseOver={(e) => cart.length > 0 && (e.target.style.transform = 'translateY(-2px)')}
                                onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                            >
                                ✅ Validate Order ({getTotalItems()})
                            </button>
                        </>
                    )}
                    
                    <button
                        className="main-header-btn"
                        style={{
                            background: '#6c757d',
                            color: 'white'
                        }}
                        onClick={logout}
                        onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                        onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                    >
                        🚪 Logout
                    </button>
                </div>
            </header>

            {/* Modals */}
            {showOrderSummary && (
                <OrderSummaryModal
                    cart={cart}
                    user={user}
                    onClose={() => setShowOrderSummary(false)}
                    onConfirm={() => {
                        // TODO: Implémenter la création de quotation Odoo
                        setShowOrderSummary(false);
                        alert('Order submitted successfully! You will receive a quotation soon.');
                        cancelOrder();
                    }}
                />
            )}

            {showCancelModal && (
                <CancelOrderModal
                    onConfirm={confirmCancelOrder}
                    onCancel={() => setShowCancelModal(false)}
                />
            )}
        </>
    );
};

export default AdaptiveHeader;
